import {Component, OnInit, ViewChild, ElementRef, Inject  } from '@angular/core';
import { AuthService } from '../../servicios/auth.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import { FileUploader } from 'ng2-file-upload';
import { DOCUMENT } from '@angular/common';
import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'app-home-root',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  
  // carousel1
  items: Array<any> = [];

  title = 'SIDEU - Sistema para la gestion de deudas';
  url;
  image;
  foto;
  idsec;
  noti;
  role;
  // para fs 1
  elem;

  constructor( 
    private auth: AuthService,
    private http: HttpClient,
    private global: GlobalService,
    @Inject(DOCUMENT) private document: any ) { 
      this.role = localStorage.getItem('role');

      // carousel2
      this.items = [
        { name: 'https://www.urgara.org.ar/images/logos/urgara_bw_s.png'},
        { name: '../../../assets/img/ANDRADA.png'},
        { name: '../../../assets/img/IOSA.png'},
        { name: '../../../assets/img/TABLETA.png'},
        { name: '../../../assets/img/CHROMA.png'},
      ];
     }

     openFullscreen() {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    }

    /* Close fullscreen */
    closeFullscreen() {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }

  // tslint:disable-next-line: member-ordering

  cantidad;
  getNoti() {
    // http://localhost:1337/api/nuevaope/getNoti
    this.http.get(`${environment.backendUrl}/api/nuevaope/getNoti`)
    .subscribe((datos: any[]) => {
      if ( datos ) {
        this.cantidad = datos[0]['cantid'];
        // console.log('cantid:', this.cantidad);
      } else {
        // console.warn("NO HAY");
      }
    });

  }

  ngOnInit() {
    this.getNoti();
    // console.log("**HOLA: " + this.global.iduser);
    this.idsec = localStorage.getItem('seccional');
    this.role = localStorage.getItem('role');
    // console.log(this.role);
    // this.llenarNoti();

    // para fs 2
    this.elem = document.documentElement;
    // this.openFullscreen();

    window.scroll(0, 0);

    // console.log('ngOnInit home lanzado..');

    // blanqueo los posibles options y localstorage menos el usuario asi permanece logueado
    localStorage.removeItem('verpagoscatego');
    localStorage.removeItem('verpagosuser');
    localStorage.removeItem('verpagosestado');

    // this.openFullscreen();


    // llena la notifi noti del navbar

    // if (this.idsec){
    //  this.llenarNoti();
   // }
  }

  // llenarNoti() {
  //   if (this.role === 'PAGADOR') {
  //     // http://localhost:1337/api/jorgenotifi/noti?est=AUTORIZADO
  //     this.http.get(`${environment.backendUrl}/api/jorgenotifi/noti?est=AUTORIZADO`)
  //       .subscribe((data: any[]) => {
  //       this.noti = data[0]['TOT'];
  //       localStorage.setItem('notipend', this.noti);
  //       console.log(`noti= ${localStorage.getItem('notipend')}`);
  //     });
  //   } else{
  //   // http://localhost:1337/api/notifi/noti?idse=21&est=PENDIENTE
  //   this.http.get(`${environment.backendUrl}/api/notifi/noti?idse=${this.idsec}&est=PENDIENTE`)
  //     .subscribe((data: any[]) => {
  //     this.noti = data[0]['TOT'];
  //     localStorage.setItem('notipend',this.noti);
  //     console.log(`noti= ${localStorage.getItem('notipend')}`); 
  //   });
  //   }

  // }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    this.role = localStorage.getItem('role');
    // console.log(this.role);
  }

}
